// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"99581a32","453":"4c8c3dd1","533":"c349373a"}[chunkId] + ".chunk.js";
};